//region [IMPORT]

// === CONSTANTS ===
import { FAILURE_CODE, SUCCESS_CODE } from "constants/general";

//#endregion

//#region [VALUES]

const REGEX_DATE_LONG           = /^(0?[1-9]|1[012])[/-](0?[1-9]|[12][0-9]|3[01])[/-]\d{4}$/;
const REGEX_DATE_MINI           = /^(0?[1-9]|1[012])[/-](0?[1-9]|[12][0-9]|3[01])[/-]\d{2}$/;
const REGEX_DATE_LONG_NO_DELIMS = /^(0?[1-9]|1[012])(0?[1-9]|[12][0-9]|3[01])\d{4}$/;
const REGEX_DATE_MINI_NO_DELIMS = /^(0?[1-9]|1[012])(0?[1-9]|[12][0-9]|3[01])\d{2}$/;

//#endregion

//#region [METHOD] === EXTERNAL

//-----------------------------------------------------------------
function validate(content='', validation_info) {
  //-----------------------------------------------------------------
  content = content.replaceAll(',', '');

  const has_validation = !!validation_info;
  const has_content    = content !== '';

  if( !has_validation || !has_content ) {
    return { content, status: SUCCESS_CODE };
  }

  validation_info = _normalizeValidationInfo( validation_info );

  const result = _format(content, validation_info);

  if (result.status !== FAILURE_CODE && (validation_info.Min !== '' || validation_info.Max !== '')) {
    handleMinMax(result, validation_info.Min, validation_info.Max);
  }

  return result;
};

//#endregion

//#region [METHOD] === INTERNAL

//-----------------------------------------------------------------
function _normalizeValidationInfo( info ) {
  //-----------------------------------------------------------------
  let normalized_info = {
    CenturySwitchYearForTwoDigits :  20  ,
    ClosestDateIsBest             : 'no' ,
    Separator                     : '/'  ,
    Order                         : '2'  ,
    Max                           : ''   ,
    Min                           : ''   ,
  };

  // CenturySwitchYearForTwoDigits
  if (info.CenturySwitchYearForTwoDigits !== undefined || info.CenturySwitchYearForTwoDigits !== '') {
    normalized_info.CenturySwitchYearForTwoDigits = parseInt(info.CenturySwitchYearForTwoDigits);
  }

  // ClosestDateIsBest
  if (info.ClosestDateIsBest !== undefined || info.ClosestDateIsBest !== '') {
    normalized_info.ClosestDateIsBest = info.ClosestDateIsBest;
  }

  // Max
  if (info.Max !== undefined || info.Max !== '') {
    normalized_info.Max = info.Max;
  }

  // Min
  if (info.Min !== undefined || info.Min !== '') {
    normalized_info.Min = info.Min;
  }

  // Order
  if (info.Order !== undefined || info.Order !== '') {
    normalized_info.Order = info.Order;
  }

  // Separator
  if (info.Separator !== undefined || info.Separator !== '') {
    normalized_info.Separator = info.Separator;
  }

  return normalized_info;
};


//-----------------------------------------------------------------
function _format(content, validation_info) {
  //-----------------------------------------------------------------
  const result = {
    content: content,
    message: '',
    status: 0,
  };

  const {
    CenturySwitchYearForTwoDigits,    
  } = validation_info;


  // NOTE: should we handle "empty string" in SimpleField.js for all fields?
  const is_empty     = content === '';
  const is_too_short = content.length < 6;

  if ( is_empty ) {
    result.content = content;
    result.status = 0;

  } else if ( is_too_short ) {
    result.status = FAILURE_CODE;
    result.message = 'Invalid date!';

  } else if ( content.match(REGEX_DATE_LONG) ) {
    result.content = content;
    result.status = SUCCESS_CODE;

  } else if ( content.match(REGEX_DATE_MINI) ) {
    result.content = _formatDateMini(content, CenturySwitchYearForTwoDigits);
    result.status = SUCCESS_CODE;

  } else if ( content.length === 8 && content.match(REGEX_DATE_LONG_NO_DELIMS)) {
    const parsedContent = _formatDateLongNoDelims(content);
    if (parsedContent.match(REGEX_DATE_LONG)) {
      result.content = parsedContent;
      result.status = SUCCESS_CODE;
    } else {
      result.status = FAILURE_CODE;
      result.message = 'Invalid date!';
    }

  } else if (content.match(REGEX_DATE_MINI_NO_DELIMS)) {
    result.content = _formatDateMiniNoDelims(content, CenturySwitchYearForTwoDigits);
    result.status = SUCCESS_CODE;

  } else {
    result.status = FAILURE_CODE;
    result.message = 'Invalid date!';
  }

  return result;
};

//-----------------------------------------------------------------
function _formatDateMini(date, century_switch) {
  //-----------------------------------------------------------------
  // determine century
  const year    = date.slice(-2);
  const century = year >= century_switch ? '19' : '20';

  const new_date = date.slice(0, -2) + century + year; 

  return new_date;
};

//-----------------------------------------------------------------
function _formatDateMiniNoDelims(date, century_switch) {
  //-----------------------------------------------------------------
  const month   = date.slice( 0, 2 );
  const day     = date.slice( 2, 4 );
  const century = date.slice( -2 ) >= century_switch ? '19' : '20';
  const year    = century + date.slice( -2 );

  return month + '/' + day + '/' + year;
};

//-----------------------------------------------------------------
function _formatDateLongNoDelims( date ) {
  //-----------------------------------------------------------------
  const month = date.slice(0, 2);
  const day   = date.slice(2, 4);
  const year  = date.slice(-4);

  return month + '/' + day + '/' + year;
};

//-----------------------------------------------------------------
function handleMinMax(result, min, max) {
  //-----------------------------------------------------------------
  const content = new Date(result.content);
  min = new Date(min);
  max = new Date(max);

  if (content < min || content > max) {
    result.status = FAILURE_CODE;
    result.message = 'Value must be between ' + min.toLocaleDateString() + ' and ' + max.toLocaleDateString() + '.';
  } else {
    result.status = SUCCESS_CODE;
  }

  return result;
};

//#endregion

export { validate }